import CampaignPages from './CampaignPages.vue'

export default CampaignPages
